import React, { useState } from 'react';
import { connect } from 'react-redux';
import { toggle } from '../Actions/SizeGuide.action';

const SizeGuide = sizeGuide => {
    const { toggle } = sizeGuide;
    const {
        tableList,
        infoList,
        title,
        gender,
        sizeDescription,
        imageDescription,
        imageUrl,
    } = sizeGuide.payload;

    const sizeGuideHeight = window.innerHeight - document.getElementById('header').offsetHeight;
    const [tableIndex, setTableIndex] = useState(0);

    return (
        <div className="cart cart--mini">
            <div
                className={`cart__info ${
                    !sizeGuide.showInfo ? 'cart__info--hidden' : ''
                }`}
                style={{height: sizeGuideHeight, overflowY: 'scroll'}}
            >
            <div className="mini-cart-content-wrapper">
              <div className="row">
                <div className="columns">
                  <span
                      id="size-guide-close"
                      className="cart__close-button"
                      onClick={() => toggle()}
                  >
                  <img src="/ui/images/close_black.svg" alt="Close icon"/>
                  </span>
                  <h3 className="size-title">{title}</h3>
                  <p className="gender-title text-italic">{gender}</p>
                  <div className="row size-tabs">
                      {tableList &&
                          tableList.map((table, index) => {
                              return (
                                  <a
                                      className={index === tableIndex ? 'tab-nav active' : 'tab-nav'}
                                      key={index}
                                      onClick={() => setTableIndex(index)}
                                  >
                                      {table.title
                                          ? table.title
                                          : `index ${index}`}
                                  </a>
                              );
                          })}
                  </div>

                      {tableList && tableList[tableIndex] && (
                          <div className="table-holder"
                              dangerouslySetInnerHTML={{
                                  __html: tableList[tableIndex].table,
                              }}
                          />
                      )}
                      <div className="size-image-wrapper">
                      {imageDescription && (
                          <div className="size-legend-text"
                              dangerouslySetInnerHTML={{
                                  __html: imageDescription,
                              }}
                          />
                      )}
                      <img className="product-detail__image--alter" itemProp="image" src={imageUrl} />

                      </div>
                      <hr></hr>
                      {infoList &&
                          infoList.map((info, index) => {
                              return (
                                  <div key={index}>
                                      <p>{info.title}</p>
                                      <p
                                          dangerouslySetInnerHTML={{
                                              __html: info.text,
                                          }}
                                      ></p>
                                  </div>
                              );
                          })}

                  <p>{sizeDescription}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
};

const mapStateToProps = state => {
    const { sizeGuide } = state;
    return {
        ...sizeGuide,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        toggle: () => dispatch(toggle()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SizeGuide);
